import useAppSelector from 'hooks/useAppSelector';

const useCalendarBodyRefreshRequest = () => {
  return useAppSelector((state) => state.stackedCalendar.bodyRefreshRequest);
};

export default useCalendarBodyRefreshRequest;
